module.exports = __webpack_public_path__ + "img/feature-1-ikea.f83f88ca.png";